import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import BlogCard from "./BlogCard";
import {
  selectAllBlogs,
  fetchAllBlogsAsync,
} from "../../../features/HomePage/homeSlice";

const Blog = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const blogs = useSelector(selectAllBlogs);
  const blogList = blogs || []; // Assuming blogs come wrapped in { data: [...] }

  useEffect(() => {
    dispatch(fetchAllBlogsAsync());
  }, [dispatch]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredPosts = blogList?.filter((post) => {
    const query = searchQuery?.toLowerCase();
    return (
      post?.Title?.toLowerCase()?.includes(query) ||
      post?.ManufactureName?.toLowerCase()?.includes(query) ||
      post?.CategoryName?.toLowerCase()?.includes(query) ||
      post?.Description?.toLowerCase()?.includes(query)
    );
  });
  

  const featured = filteredPosts[0];

  return (
    <div className="p-4 md:px-8 max-w-full mx-auto">
      {/* Search Bar and Heading */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-3">
        <h1 className="text-xl font-extrabold text-black-1">Search Articles</h1>
        <div className="flex items-center bg-white-1 border border-gray-400 rounded-sm px-2 w-full sm:w-[300px]">
          <Search className="text-gray-500" fontSize="small" />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search Blog"
            className="w-full p-2 outline-none text-sm text-black-1"
          />
        </div>
      </div>

      {/* Featured Post */}
      {featured && (
        <div className="w-full flex flex-col md:items-center lg:flex-row gap-4 mb-4">
          <img
            src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_BLOGS_IMAGE/${
              featured.Image || ""
            }`}
            alt={featured?.Title}
            className="w-full lg:w-1/2 h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-md"
          />
          <div className="flex flex-col">
            <h3 className="text-lg font-bold text-black-1 mt-2 lg:mt-0">
              {featured?.Title}
            </h3>
            <p className="text-sm text-gray-600 mt-1">{featured?.Description}</p>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-[12px]">
                {featured?.CategoryName}
              </span>
              <span className="bg-[#e3e3e3] rounded-sm px-2 py-1 text-black-1 text-[12px]">
                {featured?.ManufactureName}
              </span>
            </div>
            <Link
              to={`/blog/${featured?.BlogID}`}
              className="mt-3 text-blue text-[13px] inline-flex items-center gap-1 underline hover:text-blue-800"
            >
              Read More <ArrowForwardIcon fontSize="small" />
            </Link>
          </div>
        </div>
      )}

      <h2 className="text-black-1 font-bold mb-4 text-[18px]">Top Posts</h2>

      {/* Blog Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredPosts?.map((post) => (
          <BlogCard post={post} key={post?.BlogID} />
        ))}
      </div>
    </div>
  );
};

export default Blog;
